import React, { useState, Fragment } from 'react';
import * as PropTypes from 'prop-types';

import { APPOINTMENT_CHANNEL_ID } from '../../../../constants';
import SequentialSurveyPopup from '../../../SequentialSurveyPopup';
import ProgramPopup from '../../../common/ProgramPopup';
import { STATUS_SURVEY } from './constants';
import { ViewSurvey } from './ViewSurvey';
import styles from './index.styl';

export function VisitSurveyList({ formatMessage, appointment }) {
  const [assignmentId, setAssignmentId] = useState(null);
  const [targetUserId, setTargetUserId] = useState(null);
  const titleSurveys = formatMessage({
    id: 'appointment.surveys.title',
  });

  const allSurveys = appointment ? appointment.surveyAssignments : [];

  return (
    <div className={styles.root}>
      <div className={styles.visitSurveyHeader}>
        <div className={styles.visitSurveyTitle}>{titleSurveys}</div>
      </div>
      {allSurveys.length === 0 ? (
        <div>-</div>
      ) : (
        <Fragment>
          {allSurveys.map(surveyEntity => {
            const {
              assignmentId: id,
              status,
              survey: { name, id: surveyId, surveyType },
              interviewee: { id: intervieweeId },
            } = surveyEntity;

            switch (status) {
              case STATUS_SURVEY.COMPLETED:
                return (
                  <ProgramPopup
                    date={appointment.dateTime}
                    openedAssignmentId={id}
                    openedSurveyId={surveyId}
                    targetUserId={intervieweeId}
                    activeChannelId={APPOINTMENT_CHANNEL_ID}
                    forceFetch
                    pdfExportable
                    key={id}
                  >
                    <ViewSurvey
                      formatMessage={formatMessage}
                      status={status}
                      id={id}
                      name={name}
                      surveyType={surveyType}
                      setAssignmentId={setAssignmentId}
                      isCompletedSurvey
                      targetUserId={intervieweeId}
                      setIntervieweeId={setTargetUserId}
                    />
                  </ProgramPopup>
                );

              case STATUS_SURVEY.UPCOMING:
                return (
                  <ViewSurvey
                    formatMessage={formatMessage}
                    status={status}
                    id={id}
                    name={name}
                    surveyType={surveyType}
                    setAssignmentId={setAssignmentId}
                    targetUserId={intervieweeId}
                    setIntervieweeId={setTargetUserId}
                    isCompletedSurvey={false}
                    key={id}
                  />
                );

              default:
                return (
                  <ViewSurvey
                    formatMessage={formatMessage}
                    status={status}
                    id={id}
                    name={name}
                    surveyType={surveyType}
                    setAssignmentId={setAssignmentId}
                    isCompletedSurvey={false}
                    isExpired
                    targetUserId={intervieweeId}
                    setIntervieweeId={setTargetUserId}
                    key={id}
                  />
                );
            }
          })}
          {assignmentId && (
            <SequentialSurveyPopup
              assignmentId={assignmentId}
              onClose={() => setAssignmentId(null)}
              targetUserId={targetUserId}
            />
          )}
        </Fragment>
      )}
    </div>
  );
}

VisitSurveyList.propTypes = {
  formatMessage: PropTypes.func,
  appointment: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitSurveyListView/index.jsx